import Siema from 'siema';

const gallery = document.querySelector<HTMLElement>('[data-gallery]');
const slider = document.querySelector<HTMLElement>('[data-slider]');

if (slider && slider.childElementCount > 0) {
	const mySiemaSlider = new Siema({
		loop: true,
		selector: slider,
		duration: 1000,
		easing: 'cubic-bezier(.27,.22,.04,1)',
	});
	setInterval(() => mySiemaSlider.next(), 8000);
}

if (gallery) {
	const imgs = gallery.querySelectorAll<HTMLElement>('img');

	const addDots = () => {
		const dots = document.createElement('div');
		dots.classList.add('gallery__dots');

		imgs.forEach((img, i) => {
			const dot = document.createElement('button');

			dot.classList.add('gallery__dot');

			dot.setAttribute('role', 'button');
			dot.setAttribute('aria-label', `Visa bild ${i + 1}`);

			dot.addEventListener('click', (e) => {
				mySiemaWithDots.goTo(i);
			});

			dots.appendChild(dot);
		});

		gallery.parentNode?.appendChild(dots);
	};

	const updateDots = (currentSlide: number) => {
		const buttons = document.querySelectorAll('.gallery__dots button');

		buttons.forEach((dot, i) => {
			const addOrRemove = currentSlide === i ? 'add' : 'remove';
			dot.classList[addOrRemove]('gallery__dot--active');
		});
	};

	const mySiemaWithDots = new Siema({
		loop: true,
		selector: gallery,
		onInit: function () {
			addDots();
			updateDots(0);
		},
		onChange: function () {
			updateDots(this.currentSlide);
		},
	});
}
